import { normalizeColorHex } from '@/lib/utils';
import { mapInvoiceStatusFromDTO } from '@/modules/common/mappers/invoice-status.mapper';
import { InvoiceListItem } from '@/modules/finance/invoices/types';
import { InvoiceSummaryResponse } from '@/modules/finance/invoices/types/dto/response/invoice-summary.response';
import { formatDateRange } from '@/utils/date-formatters';

import {
  mapInvoiceSyncErrorFromResponse,
  mapInvoiceSyncOperationFromDTO,
} from './invoice-sync.mapper';

/**
 * Maps InvoiceSummaryResponse from API to domain InvoiceListItem
 */
export const mapInvoiceSummaryFromResponse = (
  response: InvoiceSummaryResponse
): InvoiceListItem => {
  const datePeriod =
    !response.startDate || !response.endDate
      ? ''
      : formatDateRange(response.startDate, response.endDate);

  return {
    id: response.id,
    number: response.referenceNumber,
    externalId: response.externalId,
    project: response.project
      ? {
          id: response.project.id,
          name: response.project.name,
          status: response.project.status,
          colorHex: normalizeColorHex(response.project.colorHex) ?? '',
          logoUrl: response.project.logoUrl,
        }
      : null,
    client: {
      id: response.client.id,
      name: response.client.name,
      logoUrl: response.client.logoUrl,
    },
    status: mapInvoiceStatusFromDTO(response.status),
    issuedDate: new Date(response.issuedDate),
    dueDate: new Date(response.dueDate),
    period: datePeriod,
    balance: response.balance,
    amount: response.totalAmount,
    currencyCode: response.currencyCode,
    syncOperation: mapInvoiceSyncOperationFromDTO(response.syncOperation),
    syncError: mapInvoiceSyncErrorFromResponse(response.syncError),
  };
};

/**
 * Maps array of InvoiceSummaryResponse to array of InvoiceListItem
 */
export const mapInvoiceSummariesFromResponse = (
  responses: InvoiceSummaryResponse[]
): InvoiceListItem[] => {
  return responses.map(mapInvoiceSummaryFromResponse);
};
